<template>
    <div class="class1">
        <b-container>
            <b-row class="py-4 justify-content-md-center">
                <b-col align-self="end" cols="12" md="auto">
                    <div class="h4 font-weight-bold text-primary">Recent Activity</div>
                </b-col>
            </b-row>
            <b-row no-gutters >
                <b-col>
                    <RecentActivityCardReview class="my-2 mx-1" />
                    <RecentActivityCardPhoto class="my-2 mx-1" />
                    <RecentActivityCardReview class="my-2 mx-1" />
                </b-col>
                <b-col>
                    <RecentActivityCardPhoto class="my-2 mx-1" />
                    <RecentActivityCardReview class="my-2 mx-1" />
                    <RecentActivityCardPhoto class="my-2 mx-1" />
                </b-col>
                <b-col>
                    <RecentActivityCardPhoto class="my-2 mx-1" />
                    <RecentActivityCardReview class="my-2 mx-1" />
                    <RecentActivityCardPhoto class="my-2 mx-1" />
                </b-col>
            </b-row>
            <b-row class="py-4 justify-content-md-center">
                <b-col align-self="end" cols="12" md="auto">
                    <b-link class="text-success">
                        <b-icon icon="chevron-down" /> Show more activity in Metro Manila
                    </b-link>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<style scoped>
.class1 {
    width: 100%;
}
</style>

<script>
import RecentActivityCardReview from './RecentActivityCardReview'
import RecentActivityCardPhoto from './RecentActivityCardPhoto'

export default {
    components: {
        RecentActivityCardReview,
        RecentActivityCardPhoto
    },
    data() {
        return {

        }
    }
}
</script>